import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';

const RenderCheckboxField = ({ input, label, id }) => (
  <FormControlLabel
    id={id}
    control={<Checkbox checked={!!input.value} onChange={input.onChange} />}
    label={label}
  />
);

RenderCheckboxField.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
  input: PropTypes.object
};

export default RenderCheckboxField;
